<nav class="navbar horizontal-nav">
  <div class="title-nav">
    <a routerLink="" class="navbar-brand title-nav_link">
      <picture class="title-nav_img">
        <img src="/assets/img/voxloud-logo.svg" width="100%" />
      </picture>
    </a>
  </div>
  <button class="navbar-button" (click)="onClose()">
    <i class="fas fa-bars"></i>
  </button>
  <div class="user-actions">
    <div class="user-icon d-inline-block" display="dynamic" ngbDropdown container="body" placement="bottom-right">
      <button class="nav-link" ngbDropdownToggle>
        {{currentLang.toUpperCase()}}
      </button>
      <div class="user-icon-menu" ngbDropdownMenu>
        <button *ngFor="let lang of languages" class="btn user-icon-menu_btn btn-link text-dark" ngbDropdownItem
          (click)="setLanguage(lang.locale)">
          {{lang.name}}
        </button>
      </div>
    </div>
    <div class="user-icon d-inline-block" display="dynamic" ngbDropdown placement="bottom-right" container="body">
      <button class="nav-link" ngbDropdownToggle>
        <img class="user-icon-img" src="/assets/img/user.svg" />
      </button>
      <div class="user-icon-menu" ngbDropdownMenu>
        <div class="user-icon-menu_text text-center w-100 btn">
          <b>{{ username }}</b>
        </div>
        <button *ngIf="false" class="btn user-icon-menu_btn btn-link text-dark" ngbDropdownItem (click)="onLogout()"
          translate>
          dashboard.logout
        </button>
      </div>
    </div>
  </div>
</nav>

<div class="sidemenu-container" [ngClass]="{ 'menu-open': !closed, 'menu-close': closed }">
  <nav class="navbar vertical-nav flex-column">
    <ul class="navbar-nav sidemenu-nav">
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" (click)="onClose()" routerLink="companies">
          <span class="dropdown-vert-title" translate>dashboard.menu.companies</span>
        </a>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" (click)="onClose()" routerLink="numbers">
          <span class="dropdown-vert-title" translate>dashboard.menu.numbers</span>
        </a>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" (click)="onClose()" routerLink="integrations">
          <span class="dropdown-vert-title" translate>dashboard.menu.integrations</span>
        </a>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" style="cursor: pointer;" role="button" (click)="onClick(4)">
          <span class="dropdown-vert-title" translate>dashboard.menu.equipment</span>
          <span>
            <img class="dropdown-vert-arrow" src="/assets/img/arrow-dropdown.svg" />
          </span>
        </a>
        <div class="dropdown-vert-content" *ngIf="clicked4">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="equipment/telephony"
            translate>dashboard.menu.telephony</a>
        </div>
        <div class="dropdown-vert-content" *ngIf="clicked4">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="equipment/connectivity"
            translate>dashboard.menu.connectivity</a>
        </div>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" style="cursor: pointer;" role="button" (click)="onClick(1)">
          <span class="dropdown-vert-title" translate>dashboard.menu.sales</span>
          <span>
            <img class="dropdown-vert-arrow" src="/assets/img/arrow-dropdown.svg" />
          </span>
        </a>
        <div class="dropdown-vert-content" *ngIf="clicked1">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="sales/lead"
            translate>dashboard.menu.lead</a>
        </div>
        <div class="dropdown-vert-content" *ngIf="clicked1">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="sales/trial-link"
            translate>dashboard.menu.trial-link</a>
        </div>
        <div class="dropdown-vert-content" *ngIf="clicked1">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="sales/activation-link"
            translate>dashboard.menu.activation-link</a>
        </div>
        <div class="dropdown-vert-content" *ngIf="clicked1">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="sales/trustpilot-review"
            translate>dashboard.menu.trustpilot-review</a>
        </div>
        <div class="dropdown-vert-content" *ngIf="clicked1">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="sales/send-sms"
            translate>dashboard.menu.send-sms</a>
        </div>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" style="cursor: pointer;" role="button" (click)="onClick(2)">
          <span class="dropdown-vert-title" translate>dashboard.menu.internal-facilities</span>
          <span>
            <img class="dropdown-vert-arrow" src="/assets/img/arrow-dropdown.svg" />
          </span>
        </a>
        <div class="dropdown-vert-content" *ngIf="clicked2">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="internal-facilities/email-signature"
            translate>dashboard.menu.email-signature</a>
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="internal-facilities/ai-assistant"
          translate>dashboard.menu.ai-assistant</a>
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="internal-facilities/feature-flags"
          translate>dashboard.menu.feature-flags</a>
        </div>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" style="cursor: pointer;" role="button" (click)="onClick(3)">
          <span class="dropdown-vert-title" translate>dashboard.menu.marketing</span>
          <span>
            <img class="dropdown-vert-arrow" src="/assets/img/arrow-dropdown.svg" />
          </span>
        </a>
        <div class="dropdown-vert-content" *ngIf="clicked3">
          <a class="dropdown-vert-content-link" (click)="onClose()" routerLink="marketing/offer-link"
            translate>dashboard.menu.offer-link</a>
        </div>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" (click)="onClose()" routerLink="kpi">
          <span class="dropdown-vert-title" translate>dashboard.menu.kpi</span>
        </a>
      </li>
      <li class="dropdown-vert">
        <a class="dropdown-vert-link" (click)="onClose()" routerLink="reviews">
          <span class="dropdown-vert-title" translate>dashboard.menu.reviews</span>
        </a>
      </li>
    </ul>
  </nav>
</div>

<div class="main-page" [ngClass]="{ 'menu-open': !closed, 'menu-close': closed }">
  <router-outlet></router-outlet>
</div>